import React from 'react';
import './AccountAvatarPlaceholder.css';

/**
 * Grafika zastępcza dla konta niewidocznego publicznie (deaktywowane) lub zablokowanego (na później).
 */
function InactiveGraphic() {
  return (
    <>
      <circle cx="24" cy="24" r="22" fill="#edeceb" stroke="#d6d3d1" strokeWidth="1.25" />
      <circle cx="24" cy="17.5" r="5.2" fill="#a8a29e" />
      <path
        d="M12.5 38.5c1.2-6.2 5.8-10 11.5-10s10.3 3.8 11.5 10"
        fill="none"
        stroke="#a8a29e"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <rect x="29" y="25" width="2.8" height="9" rx="1" fill="#78716c" />
      <rect x="33.4" y="25" width="2.8" height="9" rx="1" fill="#78716c" />
    </>
  );
}

function BannedGraphic() {
  return (
    <>
      <circle cx="24" cy="24" r="22" fill="#fef2f2" stroke="#fca5a5" strokeWidth="1.35" />
      <circle cx="24" cy="17.5" r="5.2" fill="#dc2626" opacity="0.85" />
      <path
        d="M12.5 38.5c1.2-6.2 5.8-10 11.5-10s10.3 3.8 11.5 10"
        fill="none"
        stroke="#dc2626"
        strokeWidth="3.2"
        strokeLinecap="round"
        opacity="0.85"
      />
      <path
        d="M14 14 L34 34"
        stroke="#b91c1c"
        strokeWidth="2.75"
        strokeLinecap="round"
      />
    </>
  );
}

export function AccountAvatarPlaceholder({ variant = 'inactive', className = '', title }) {
  return (
    <span
      className={`account-avatar-placeholder account-avatar-placeholder--${variant} ${className}`.trim()}
      role={title ? 'img' : 'presentation'}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
    >
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        {variant === 'banned' ? <BannedGraphic /> : <InactiveGraphic />}
      </svg>
    </span>
  );
}
